import { render, staticRenderFns } from "./MerchantGatewayList.vue?vue&type=template&id=27a6bd9f&"
import script from "./MerchantGatewayList.vue?vue&type=script&lang=js&"
export * from "./MerchantGatewayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports